/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

export const NotFoundComponent = (props: { error: string; msg: string }) => (
    <>
        <div className='msc-add-line-to-template__not-found__icon' />
        <div className='msc-add-line-to-template__not-found__msg'>{props.error}</div>
        <div className='msc-add-line-to-template__not-found__remediation-instructions'>{props.msg}</div>
    </>
);
